import * as serviceWorkerRegistration from '../serviceWorkerRegistration.js';
import { clearAllCachedData as underlyingClearAllCachedData } from '@soulhx/client-store';

const refreshCacheAndReload = () => {
  if ('serviceWorker' in navigator) {
    serviceWorkerRegistration.unregister();
    caches
      .keys()
      .then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      })
      .then(() => {
        serviceWorkerRegistration.register();
      });
  }
};

/**
 * Clears cached data from every cache, to be used for logout
 * scenarios.
 */
export const clearAllCachedData = async () => {
  await underlyingClearAllCachedData();
  refreshCacheAndReload();
};
